export default __webpack_public_path__ + "static/media/music_club_thumb.32614905.png";